// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

type RequireContext = __WebpackModuleApi.RequireContext;

interface ComponentDictionary {
    [key: string]: React.ComponentType<any>;
}

export function buildIconsObject(foundIcons: RequireContext) {
    const iconObject: ComponentDictionary = {};
    for (const iconKey of foundIcons.keys()) {
        const name = iconKey.replace("./", "").replace(".tsx", "");
        const iconComponent = foundIcons(iconKey).default as React.ComponentType<any>;
        if (iconComponent) {
            iconObject[name] = iconComponent;
        }
    }
    return iconObject;
}

// if we don't exclude the current file, we end up with a circular dependency and module loading fails
const icons = require.context("./", true, /\/(?!xngCommonIcons).+\.tsx$/);
const xIconsObject = buildIconsObject(icons);

export default xIconsObject;
